<template>
    <div class="page-index">
        <div class="hd">
            <div class="info">
                <div class="info-hd">付款给</div>
                <div class="info-bd">{{ hospitalName }}</div>
            </div>
            <div class="info-icon">
                <img class="info-icon-img" src="../../assets/info-icon.png" alt="">
            </div>
            <div class="bg"></div>
        </div>
        <div class="bd">
            <div class="box">
                <div class="box-hd">
                    <div class="box-hd-label">费用总额</div>
                    <div class="box-hd-value">{{ feeSumamt }} 元</div>
                </div>
                <div class="box-bd">
                    <div class="box-item">
                        <div class="box-bd-label">医保基金支付</div>
                        <div class="box-bd-value">{{ fundPay }} 元</div>
                    </div>
                    <div class="box-item">
                        <div class="box-bd-label">个人帐户支付</div>
                        <div class="box-bd-value">{{ psnAcctPay }} 元</div>
                    </div>
                </div>
                <div class="box-ft">
                    <div class="box-ft-label">现金支付</div>
                    <div class="box-ft-value">{{ ownPayAmt }} 元</div>
                </div>
                <div
                        class="box-append"
                        @click="handleActionsheet">
                    查看明细
                </div>
            </div>
            <div class="bd-append">
                <i class="bd-append-icon"></i>
                <div class="bd-append-text">医保移动支付</div>
            </div>
        </div>
        <div class="ft">
            <div class="pay">
                <div class="pay-label">您还需支付：</div>
                <div class="pay-value">¥{{ ownPayAmt }}</div>
            </div>
            <div class="btn" @click="pay">去支付</div>
        </div>
        <div
                class="actionsheet"
                v-show="actionsheetVisible">
            <div class="actionsheet-mask" @click="handleActionsheet"></div>
            <div class="actionsheet-panel">
                <div class="actionsheet-hd">
                    <div class="actionsheet-hd-tt">处方明细</div>
                    <i class="actionsheet-icon-close" @click="handleClose"></i>
                </div>
                <div class="actionsheet-bd">
                    <div
                            class="actionsheet-box"
                            v-for="item in prescriptionList"
                            :key="item.title">
                        <div class="actionsheet-box-hd">{{item.title}}</div>
                        <div class="actionsheet-box-bd">
                            <div
                                    class="actionsheet-box-item"
                                    v-for="boxItem in item.list"
                                    :key="boxItem.label">
                                <div class="actionsheet-box-item-label-wrap">
                                    <div class="actionsheet-box-item-label">{{boxItem.label}}</div>
                                    <div class="actionsheet-box-item-sublabel">{{boxItem.subLabel}}</div>
                                </div>
                                <div
                                        class="actionsheet-box-item-value"
                                        :class="[boxItem.highlight ? 'em' : '']">{{boxItem.value}}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import {getQueryString} from '../../utils/common'
    import {createOrder, presettle, queryBillsInfo,verifyBill} from '../../api/Api'
    import {Toast} from 'vant'

    export default {
        name: 'PageIndex',
        data() {
            return {
                hospitalName: '伊犁哈萨克自治州友谊医院',
                //现金部分
                ownPayAmt: '',
                //医保基金部分
                fundPay: '',
                //个人账户支出部分
                psnAcctPay: '',
                //费用总额
                feeSumamt: '',
                prescription: [],
                prescriptionList: [],
                actionsheetVisible: false,
                medOrgOrd: '',
                authCode: '',
                retCode: '',
                type: '',
            }
        },
        methods: {
            handleActionsheet() {
                this.actionsheetVisible = true;
            },
            handleClose() {
                this.actionsheetVisible = false;
            },
            async queryBillsInfo() {
                Toast.loading({
                    message: '查询中...', duration: 0
                });
                this.prescriptionList = [];
                let ret = await queryBillsInfo(this.medOrgOrd);
                Toast.clear();
                if (ret.status !== 200) {
                    Toast.fail("未查询到处方信息");
                    return;
                }
                console.log(ret);
                let prescription = ret.data.prescription;
                let plist = [
                    {label: '门诊类别', value: prescription.payType},
                    {label: '门诊科室', value: prescription.dept},
                    {label: '医生姓名', value: prescription.doctor},
                    {label: '处方时间', value: prescription.createDate},
                    {label: '费用总额', value: prescription.totalFee + '元', highlight: true},
                ]
                let one = {
                    title: '就诊信息',
                    list: plist
                }
                this.prescriptionList.push(one);

                let diseaseInfos = ret.data.diseaseInfos;
                if (diseaseInfos != null && diseaseInfos.length > 0) {
                    let dInfos = [];
                    for (let key of diseaseInfos) {
                        let d = {label: '诊断名称', value: key.diseName};
                        dInfos.push(d);
                        d = {label: '诊断编号', value: key.diseCode};
                        dInfos.push(d);
                    }
                    let tow = {
                        title: '诊断信息',
                        list: dInfos
                    }
                    this.prescriptionList.push(tow);
                }
                if (ret.data.item != null && ret.data.item.length > 0) {
                    let itmes = []
                    for (let key of ret.data.item) {
                        let item = {
                            label: key.name + "*" + key.quantity,
                            subLabel: key.spec + "/" + key.unit + "/" + key.price,
                            value: key.cost + '元'
                        }
                        itmes.push(item)
                    }
                    let third = {
                        title: '费用信息',
                        list: itmes
                    }
                    this.prescriptionList.push(third);
                }
            },
            async pay() {
                //验证处方信息,确保医生没有修改原处方
                Toast.loading({
                    message: '验证处方信息...', duration: 0
                });
                console.log("medOrgOrd", this.medOrgOrd)
                let billRet = await verifyBill(this.medOrgOrd);
                Toast.clear();
                if (billRet.status !== 200) {
                    Toast.fail(billRet.message);
                    return;
                }

                if(billRet.data == "0"){
                    //发起医保结算
                    Toast.loading({
                        message: '创建订单...', duration: 0
                    });
                    let p = {
                        merOrgOrd: this.medOrgOrd,
                        type: this.type
                    }
                    let ret = await createOrder(p);
                    Toast.clear();
                    if (ret.status !== 200) {
                        Toast.fail("创建订单失败");
                        return;
                    }
                    window.location.href = ret.data.payUrl;
                } else {
                    Toast.fail("处方验证失败,请稍后重试");
                    return;
                }
            },
            /**
             * 预结算
             */
            async doPreSettle(medOrgOrd, authCode) {
                Toast.loading({
                    message: '正在预结算...', duration: 0
                });
                let ret = await presettle(medOrgOrd, authCode);
                Toast.clear();
                if (ret.status !== 200) {
                    Toast.fail(ret.message);
                    return;
                }
                if (ret.data.code !== "0000") {
                    Toast.fail(ret.data.message);
                    return;
                }
                this.ownPayAmt = ret.data.ownPayAmt;
                //医保基金部分
                this.fundPay = ret.data.fundPay;
                //个人账户支出部分
                this.psnAcctPay = ret.data.psnAcctPay;
                //费用总额
                this.feeSumamt = ret.data.fee;
            }
        },
        mounted: function () {
            this.$nextTick(async function () {
                window.document.title = "医保移动支付";
                this.medOrgOrd = getQueryString("medOrgOrd")
                this.authCode = getQueryString("authCode")
                this.retCode = getQueryString("retCode")
                this.type = getQueryString("type")
                if (this.retCode !== '0') {
                    Toast.fail("授权失败");
                    return;
                }
                await this.queryBillsInfo();
                await this.doPreSettle(this.medOrgOrd, this.authCode);
            })
        }
    }
</script>

<style scoped>
    @import '../../assets/index.css';
    @import '../../assets/actionsheet.css';
</style>
